module.exports = __webpack_public_path__ + "static/media/cloudy-day-3.109368f6.svg";